module.exports = "https://cdn.hellotech.com/client-assets/HT-fees-hdr-mobile_1ae9bea9fd5f4257eeb55189538ee1b7.jpg";